import { observable, makeAutoObservable } from 'mobx';
import {types, endpoints} from 'main/tools';
import {NotificationRecipient} from 'main/stores/documents';
import {DomainStore} from 'shared/store';
import {User} from 'main/stores/users';
import _ from 'lodash';

class EmployeeDocumentState {
  store = new DomainStore();

  document;
  isUploading = false;
  errors = {};
  users = [];

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.USERS.ACTIVE
    ]);

    this.users = this.store._getAll(types.USER, User);
  }

  receiveProps({document, errors}) {
    this.document = document;
    this.errors = errors;
  }

  updateFile(files) {
    const file = _.head(files);
    file ? this.mergeFile(file) : this.removeFile();
  }

  mergeFile(file) {
    this.document.merge({originalFile: file});
  }

  removeFile() {
    this.document.originalFile = null;
  }

  onUploadStarted() {
    this.isUploading = true;
  }

  async onUploadFinished() {
    if (this.document.documentType === 'pdf_template') {
      await this.validateEncryption();
    }
    this.isUploading = false;
  }

  async validateEncryption() {
    this.errors = {};
    if (!this.document.originalFile) return;

    const pdfjsLib = await import('pdfjs-dist/build/pdf.mjs');

    pdfjsLib.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.mjs', import.meta.url).toString();

    try {
      await pdfjsLib.getDocument({url: this.document.originalFile.preview}).promise;
    } catch (error) {
      if (error.name === 'PasswordException') {
        this.errors = {
          awsFiles: 'Document is password protected. Password protected files are not supported for annotation.'
        };
      } else {
        throw error;
      }
    }
  }

  get files() {
    return this.document.originalFile ? observable([this.document.originalFile]) : observable([]);
  }

  get canSaveDocument() {
    return !!this.document.originalFile && !this.errors.awsFiles;
  }

  get recipientOptions() {
    return [
      new NotificationRecipient({
        recipientType: 'manager'
      }),
      ...this.users.map(user => new NotificationRecipient(
        {
          recipientType: 'specific_user',
          user: user
        }
      ))
    ];
  }
}

export default EmployeeDocumentState;
